import { Tabs } from 'antd'
import TabPane from 'antd/lib/tabs/TabPane'
import CustomModal from 'components/global/CustomModal'
import { useState } from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { CheckinOutAttendeeWithType } from 'types/event/eventAttendance'
import NotesTab from '../Common/NotesTab'
import CheckInOutTab from '../Common/CheckInOutTab'
import HistoryTab from '../Common/HistoryTab'

interface CheckoutStateTypes {
  checkOutModalOpen: boolean
  setCheckOutModalOpen: (state: boolean) => void
  setCheckInOutModalOpen: (state: boolean) => void
  setParticipantData: (value: CheckinOutAttendeeWithType) => void
}

const CheckOutModal = () => {
  const [tabKey, setTabKey] = useState<string>('1')
  const {
    checkOutModalOpen,
    setCheckOutModalOpen,
    setCheckInOutModalOpen,
    setParticipantData,
  }: CheckoutStateTypes = eventAttendanceStore(store => ({
    checkOutModalOpen: store.checkOutModalOpen,
    setCheckOutModalOpen: store.setCheckOutModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setParticipantData: store.setParticipantData,
  }))

  const closeModal = () => {
    setParticipantData(null)
    setCheckInOutModalOpen(true)
    setCheckOutModalOpen(false)
  }

  return (
    <>
      <CustomModal
        openModal={checkOutModalOpen}
        isCloseModalCustom
        closeModal={closeModal}
        title="Check-out details"
        width={1200}
        footer={false}
      >
        <>
          <Tabs className="" defaultActiveKey={tabKey}>
            <TabPane tab="Notes" key="1">
              <NotesTab />
            </TabPane>
            <TabPane tab="Check-out" key="2">
              <CheckInOutTab type="check-out" />
            </TabPane>
            <TabPane tab="History" key="3">
              <HistoryTab />
            </TabPane>
          </Tabs>
        </>
      </CustomModal>
    </>
  )
}

export default CheckOutModal
